import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';

@Component({
  selector    : 'template-capital-expense',
  templateUrl : './template-capital-expense.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplateCapitalExpense {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false
}
